<template>
  <v-layout class="restaurant-categories-container">
    <v-container fluid>
      <v-card>
        <v-card-title :class="{ 'mb-2': settings && settings.multipleMenus }">
          <span>{{ $t('categories') }}</span>
          <v-select
            v-if="settings && settings.multipleMenus"
            class="all-white white--text v-select--no-black font-weight-light v-select--inline col-auto ml-2"
            :items="menuOptions"
            rounded
            single-line
            v-model="selectedMenuId"
            label="Menú"
            hide-details
            background-color="#e48b46"
            dark
            color="#fff"
            item-value="id"
            solo
            flat
            dense
            item-text="name"
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            class="white--text"
            v-if="hasEditPermissions"
            @click="createNewCategory"
            >{{ $t('category.new') }}</v-btn
          >
        </v-card-title>
        <v-card-subtitle>
          {{ $t('categories.subtitle') }}
        </v-card-subtitle>
        <v-card-text>
          <template v-if="!settings || !categories">
            <v-skeleton-loader type="sentences" />
          </template>
          <template v-else-if="!categories.length">
            {{ $t('categories.empty') }}
          </template>
          <template v-else>
            <v-list-item class="category-item fixed">
              <v-list-item-avatar>
                <v-icon class="handle">push_pin</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <span class="name">
                  {{ $t('categories.discounts') }}
                </span>
                <span class="description grey--text">
                  {{ $t('categories.discountsDescription') }}
                </span>
              </v-list-item-content>
              <v-list-item-action class="flex-row align-center">
                <v-switch
                  color="green"
                  v-model="settings.showDiscounts"
                  @change="saveSettings"
                  v-if="hasSettingsPermissions"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="category-item fixed disabled">
              <v-list-item-avatar>
                <v-icon class="handle">push_pin</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <span class="name">
                  {{ $t('categories.popular') }}
                  <v-chip label x-small disabled>Proximamente</v-chip>
                </span>
                <span class="description grey--text">
                  Aquí apareceran los productos mas pedidos, si recibe pedidos
                </span>
              </v-list-item-content>
              <v-list-item-action class="flex-row align-center">
                <v-switch
                  color="green"
                  :value="false"
                  disabled
                  v-if="hasSettingsPermissions"
                ></v-switch>
              </v-list-item-action>
            </v-list-item>

            <draggable
              v-model="categories"
              @change="change"
              :disabled="!hasEditPermissions"
              :delay="500"
              :delay-on-touch-only="true"
            >
              <transition-group>
                <v-list-item
                  class="category-item"
                  v-for="cat in categories"
                  :key="cat.id"
                >
                  <v-list-item-avatar v-if="hasEditPermissions">
                    <v-icon class="handle">drag_handle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <span class="name">
                      {{ cat.name }}
                    </span>
                    <span class="description grey--text" v-if="cat.description">
                      {{ cat.description }}
                    </span>
                  </v-list-item-content>
                  <v-list-item-action class="flex-row align-center">
                    <v-btn
                      v-if="cat.posOnly"
                      fab
                      x-small
                      depressed
                      color="info"
                      @click="hasEditPermissions && edit(cat)"
                      v-tooltip="
                        'Esta categoría solo es visible en Punto de Venta'
                      "
                    >
                      <v-icon>mdi-eye-off</v-icon>
                    </v-btn>
                    <div
                      class="disabled-in-branch d-flex align-center"
                      v-if="
                        branches.length > 1 &&
                        cat.visible &&
                        !availableInBranch(cat)
                      "
                    >
                      <span>En sucursal actual</span>
                      <v-switch
                        color="green"
                        dense
                        :disabled="!hasDisablePermissions"
                        :input-value="false"
                        @change="setVisibility(cat, true, false)"
                      ></v-switch>
                    </div>
                    <v-btn
                      text
                      :to="
                        `/${restaurant.stringId}/${itemsPage}?cId=${cat.id}` +
                        (selectedMenuId ? `&mId=${selectedMenuId}` : '')
                      "
                      >{{ $t('categories.viewItems') }}</v-btn
                    >
                    <v-btn
                      v-if="cat.hourRanges === null || effectiveTier === 0"
                      icon
                      @click="editHours(cat)"
                      v-tooltip="
                        effectiveTier === 0
                          ? 'La restricción horaria solo está disponibles en los planes Plus y Pro'
                          : undefined
                      "
                    >
                      <v-icon>mdi-clock-outline</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      @click="editHours(cat)"
                      v-tooltip="
                        effectiveTier === 0
                          ? 'La restricción horaria solo está disponibles en los planes Plus y Pro'
                          : undefined
                      "
                      fab
                      x-small
                      dark
                      :color="
                        timeInsideHours(
                          cat.hourRanges,
                          branch.location ? branch.location.tz : null
                        )
                          ? '#4caf50'
                          : '#e44949'
                      "
                      depressed
                    >
                      <v-icon>mdi-clock-outline</v-icon>
                    </v-btn>
                    <v-btn icon @click="edit(cat)" v-if="hasEditPermissions"
                      ><v-icon>edit</v-icon></v-btn
                    >
                    <visibility-switch
                      :visible="
                        branches.length === 1
                          ? cat.visible && availableInBranch(cat)
                          : cat.visible
                      "
                      :only-all="branches.length === 1"
                      :branch="branch"
                      :color="
                        branches.length > 1 &&
                        cat.visible &&
                        !availableInBranch(cat)
                          ? 'orange'
                          : 'green'
                      "
                      :disabled="
                        !hasDisablePermissions ||
                        (allBranches.length !== branches.length && !cat.visible)
                      "
                      @changeAll="setVisibility(cat, $event, true)"
                      @changeBranch="setVisibility(cat, $event, false)"
                    />
                  </v-list-item-action>
                </v-list-item>
              </transition-group>
            </draggable>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
    <v-toolbar v-if="orderChanged" class="order-toolbar" dense floating>
      <span class="pr-4">{{ $t('orderChanged') }}</span>
      <v-btn @click="saveOrder" color="info" :loading="savingOrder">
        {{ $t('save') }}
      </v-btn>
    </v-toolbar>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import draggable from 'vuedraggable';
  import { ICategory } from '../../interfaces/ICategory';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import NewCategoryModal from '../modals/NewCategoryModal.vue';
  import CategoriesService from '../../api/services/categories.service';
  import RestaurantsService, {
    IRestaurantSettings,
  } from '../../api/services/restaurants.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import { IBranch } from '../../interfaces/IBranch';
  import { PermissionType } from '../../enums/PermissionType';
  import MenusService from '../../api/services/menus.service';
  import { IMenu } from '../../interfaces/IMenu';
  import HourItemsModal from '../modals/HourRangesModal.vue';
  import { ISimpleHourRange } from '../../interfaces/ISimpleHourRange';
  import { timeInsideHours } from '../../utils';
  import { IItem } from '../../interfaces/IItem';
  import VisibilitySwitch from '../partials/VisibilitySwitch.vue';
  import { getEffectiveTier } from '@/utils/billing-entitlements.utils';

  @Component({
    components: { VisibilitySwitch, draggable },
  })
  export default class RestaurantCategories extends Vue {
    categoriesService = new CategoriesService();
    restaurantsService = new RestaurantsService();
    menusService = new MenusService();
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() allBranches: IBranch[];
    @Prop() branches: IBranch[];
    settings: IRestaurantSettings = null;
    categories: ICategory[] = null;
    menus: IMenu[] = null;
    orderChanged = false;
    savingOrder = false;
    selectedMenuId = null;
    justLoad = true;
    timeInsideHours = timeInsideHours;
    get effectiveTier(): number {
      return getEffectiveTier(this.restaurant);
    }

    /** The classic pages link to each other (the Menú page replaces both). */
    get itemsPage(): string {
      return this.$route.path.endsWith('/categories/classic')
        ? 'items/classic'
        : 'items';
    }

    mounted() {
      this.init();
    }

    async init() {
      await this.loadMenus();
      await Promise.all([this.loadCategories(), this.loadSettings()]);
      this.justLoad = false;
    }

    async loadSettings() {
      this.settings = await this.restaurantsService.getSettings(
        this.restaurant.id
      );
    }

    async saveSettings() {
      try {
        await this.restaurantsService.saveSettings(
          this.restaurant.id,
          this.settings
        );
      } catch (e) {
        vueData.addAlert(
          this.$tc('categories.errorSavingSettings'),
          AlertType.Error
        );
        this.settings.showDiscounts = !this.settings.showDiscounts;
      }
    }

    async loadMenus() {
      this.menus = await this.menusService.getAll(this.restaurant.id);

      const mId = this.$route.query.mId as string;
      if (mId && mId !== 'def') {
        if (this.menus.some((value) => value.id === +mId))
          this.selectedMenuId = +mId;
        else {
          const query = Object.assign({}, this.$route.query);
          delete query.mId;
          this.$router.replace({ query });
        }
      }
    }

    availableInBranch(category: ICategory) {
      return (
        !category.hiddenBranchesIds ||
        category.hiddenBranchesIds.indexOf(this.branch.id + '') === -1
      );
    }

    @Watch('selectedMenuId')
    onSelectedMenuChanged(menuId: number) {
      if (this.justLoad) return;

      this.categories = null;

      const query = Object.assign({}, this.$route.query);
      if (menuId !== null) query.mId = menuId + '';
      else delete query.mId;
      delete query.cId;
      this.$router.replace({ query });

      this.loadCategories();
    }

    get menuOptions() {
      return [{ id: null, name: 'Menú por defecto' }, ...this.menus];
    }

    change(e) {
      if (!e.moved) return;

      const data: { element: ICategory; oldIndex: number; newIndex: number } =
        e.moved;

      this.categories.forEach((value, index) => {
        value.index = index;
      });

      this.orderChanged = true;
    }

    async saveOrder() {
      this.savingOrder = true;

      try {
        const ids = this.categories.map((value) => value.id);
        const indexes = this.categories.map((value) => value.index);

        await this.categoriesService.saveOrder(
          this.restaurant.id,
          ids,
          indexes
        );
        this.orderChanged = false;
      } catch (e) {
        vueData.addAlert(this.$tc('errors.savingOrderFailed'), AlertType.Error);
      } finally {
        this.savingOrder = false;
      }
    }

    async setVisibility(item: ICategory, val: boolean, allBranches: boolean) {
      allBranches =
        allBranches && this.branches.length === this.allBranches.length;
      const storedItem = await this.categoriesService.getById(item.id);
      const branchIds = (storedItem.hiddenBranchesIds =
        storedItem.hiddenBranchesIds ?? []);
      if (allBranches && (!branchIds.length || item.visible !== val)) {
        await this.changeVisible(val, item);
      } else {
        try {
          const index = branchIds.indexOf(this.branch.id + '');
          if (!val) {
            if (index === -1) branchIds.push(this.branch.id + '');
          } else {
            if (index > -1) branchIds.splice(index, 1);
          }
          await this.categoriesService.update(storedItem);

          item.hiddenBranchesIds = storedItem.hiddenBranchesIds;
        } catch (e) {
          console.error(e);
          vueData.serverError(e);
        }
      }
    }

    async changeVisible(newValue: boolean, category: ICategory) {
      try {
        category.visible = newValue;

        if (newValue) await this.categoriesService.activate(category);
        else await this.categoriesService.deactivate(category);
      } catch (e) {
        vueData.addAlert(
          this.$tc('errors.statusChangeFailed'),
          AlertType.Error
        );
        category.visible = !newValue;
      }
    }

    get hasSettingsPermissions() {
      return vueData.hasPermission(PermissionType.StoreSettings);
    }

    get hasEditPermissions() {
      return vueData.hasPermission(PermissionType.CatalogManage);
    }

    get hasDisablePermissions() {
      return vueData.hasPermission(PermissionType.CatalogDisable);
    }

    createNewCategory() {
      this.$modal.show(
        NewCategoryModal,
        {
          menuId: this.selectedMenuId,
          branch: this.branch,
          branches: this.branches,
          category: {
            restaurantId: this.restaurant.id,
            menuId: this.selectedMenuId,
            name: '',
            stringId: '',
            index: this.categories.length,
            hiddenBranchesIds: null,
          },
        },
        {
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadCategories();
          },
        }
      );
    }

    editHours(category: ICategory) {
      if (this.effectiveTier === 0) {
        vueData.addAlert(
          'Esta funcionalidad está disponible en planes Plus y Pro',
          AlertType.Info
        );
        return;
      }

      this.$modal.show(
        HourItemsModal,
        {
          item: category,
          type: 'category',
        },
        {
          name: 'add-item',
          adaptive: true,
          classes: 'dialog--height-limit',
          height: 'auto',
          width: 600,
          scrollable: true,
          clickToClose: false,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: (hours: ISimpleHourRange[]) => {
            category.hourRanges = hours;
          },
        }
      );
    }

    edit(category: ICategory) {
      const cat = { ...category }; //todo improve
      if (cat.hiddenBranchesIds)
        cat.hiddenBranchesIds = [...cat.hiddenBranchesIds];

      this.$modal.show(
        NewCategoryModal,
        {
          branch: this.branch,
          branches: this.branches,
          category: cat,
        },
        {
          name: 'category',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          saved: () => {
            this.loadCategories();
          },
          deleted: () => {
            this.categories.splice(this.categories.indexOf(category), 1);
            this.$modal.hide('category');
          },
        }
      );
    }

    async loadCategories() {
      const categories = await RestaurantsService.getCategories(
        this.restaurant.id,
        this.selectedMenuId
      );
      this.categories = categories;
    }
  }
</script>

<style lang="scss" scoped>
  .disabled-in-branch {
    background-color: #ffe5e5;
    border-radius: 20px;
    padding: 4px 8px 4px 12px;

    span {
      padding-right: 8px;
      text-transform: lowercase;
      font-size: 0.9em;
      color: #8a4949;
    }
  }
</style>
